<template>
  <div class="onboarding__page-container">
    <div class="onboarding__left-container">
      <img
        :src="currentStep.sidebarImg"
        class="onboarding__sidebar-img"
      >
    </div>
    <div
      class="onboarding__right-container"
    >
      <div class="right-container__main">
        <div class="onboarding__main-container">
          <div class="onboarding__title-container">
            <span class="sk-heading-large-semibold">
              {{ currentStep.title }}
            </span>
            <span
              v-if="!currentStep.stepCountHidden"
              class="onboarding__header__step-count"
            >
              {{ $t(
                'step_count', {currentStep: currentStep.stepIndex, totalStep: totalStepCount}
              ) }}
            </span>
          </div>
          <slot />
        </div>
      </div>
      <div
        v-if="!currentStep.submitHidden"
        class="right-container__footer"
      >
        <SkOroraButton
          class="footer__submit"
          data-test="onboarding-submit-step"
          :disabled="stepLoading || isSubmitDisabled"
          :spinner="stepLoading"
          @click="$emit('submit')"
        >
          {{ currentStep.submitLabel }}
        </SkOroraButton>
      </div>
    </div>
  </div>
</template>

<script>
import { SkOroraButton } from '@skelloapp/skello-ui';

export default {
  name: 'MultiStepForm',
  components: { SkOroraButton },
  props: {
    currentStep: {
      type: Object,
      required: true,
    },
    totalStepCount: {
      type: Number,
      required: true,
    },
    stepLoading: {
      type: Boolean,
      default: false,
    },
    isSubmitDisabled: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding__title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.onboarding__header__step-count {
  color: $sk-grey-50;
}

.onboarding__page-container {
  display: flex;
  height: 100vh;
}

.onboarding__sidebar-img {
  height: 100vh;
}

.onboarding__left-container {
  background-color: $sk-blue-5;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1343px), (max-height: 650px) {
    display: none;
  }
}

.onboarding__right-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  height: 100px;
  overflow-x: hidden;
}

.right-container__main {
  padding: 48px 48px 0px 48px;

  @media (min-width: $md-width) and (max-width: 1343px) {
    padding: 48px 44px 0px 40px;
  }

  @media (max-width: $md-width) {
    padding: 48px 20px 0px 40px;
  }

  @media (max-width: $sm-width) {
    padding: 48px 20px 0;
  }
  .onboarding__main-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}

.right-container__footer {
  display: flex;
  align-items: center;
  justify-content: end;
  min-height: 90px;
  height: 90px;
  border-top: 1px solid $sk-grey-10;
  position: sticky;
  bottom: 0;
  background: white;
}

.footer__back {
  color: $sk-grey-50;
  margin-left: 32px;
  cursor: pointer;
}

.footer__submit {
  margin-right: 100px;

  @media (min-width: $md-width) and (max-width: 1343px) {
    margin-right: 44px;
  }

  @media (max-width: $md-width) {
    margin-right: 20px;
  }

  @media (max-width: $sm-width) {
    margin-right: 20px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
